module.exports = __webpack_public_path__ + "7522448a19b7c28bbe3c47feedf55893.pdf";